import React, { ReactNode } from "react";

type FeatureInformationPanelProps = {
  summary: string;
  children: ReactNode;
};

const FeatureInformationPanel = ({ summary, children }: FeatureInformationPanelProps) => {
  return (
    <section
      id="feature-panel-information"
      role="tabpanel"
      aria-labelledby="feature-tab-information"
      tabIndex={0}
      className="workspace-card mt-2 overflow-hidden border border-slate-200 bg-white"
    >
      <div>
        <div className="border-b border-slate-200 bg-slate-50 px-5 py-4">
          <p className="text-sm font-semibold text-slate-800">Purpose</p>
          <p className="mt-1 text-sm leading-6 text-slate-600">{summary}</p>
        </div>
        <div className="px-5 py-4">{children}</div>
      </div>
    </section>
  );
};

export default FeatureInformationPanel;
